export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="flex items-center justify-center w-full section2-container">
        <div className="text-center w-[90%] md:w-[70%] lg:w-[60%] mx-auto">
          <h1 className="mt-[40px] mb-[1%] md:mb-0 text-[24px] leading-[29px] md:text-[40px] font-bold md:leading-[41px] text-[#151515]">
            WordPress Development
          </h1>
          <p className="leading-[22px] text-[#373737] text-base font-open max-w-[700px] mx-auto mt-10">
            At Mean3, we specialize in custom WordPress development designed to boost your business. Whether you're starting from scratch, migrating to WordPress, or need a unique solution, we are here to provide expert guidance and a seamless experience. We focus on creating WordPress websites that are not only visually stunning but also secure, fast, and user-friendly. With our expertise, your website will perform at its best and meet your business goals.
          </p>
        </div>
      </div>

      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
